"use client";

import { PageWrapper } from "@/components/core";
import {
  DNMVoucherRewardAccordion,
  PurchaseRewardAccordion,
  TotalNodePurchasesAccordion,
  UserLevelAccordion,
  WalletAssetsAccordion,
  WeeklyCalculationAccordion,
  WeeklyIncomeAccordion,
} from "@/components/features/user-dashboard";
import { Accordion } from "@/components/ui/accordion";
import { $api } from "@/lib/api-client";

export default function DashboardPage() {
  const isServerUpdating = $api.useQuery("get", "/settings/{name}", {
    params: {
      path: {
        name: "CALCULATE_WEEK_IS_UPDATING",
      },
    },
  });

  return (
    <PageWrapper className="text-sm">
      <Accordion type="multiple" className="w-full">
        <UserLevelAccordion />
        <WeeklyCalculationAccordion
          isServerUpdating={isServerUpdating.data?.data?.value}
        />
        <WeeklyIncomeAccordion />
        <DNMVoucherRewardAccordion />
        <PurchaseRewardAccordion />
        <TotalNodePurchasesAccordion
          isServerUpdating={isServerUpdating.data?.data?.value}
        />
        <WalletAssetsAccordion />
      </Accordion>
    </PageWrapper>
  );
}
